export function getClasses(name: string, modificators: ReadonlyArray<string> = []): string[] {
    return [name].concat(modificators.map((modificator) => `${name}--${modificator}`));
}
